import React, { useEffect, useRef, useState } from "react";

import type { CSSSelectorObject } from "@mui/system";
import { Box } from "@mui/material";
//@ts-expect-error Striim-ui missing type declarations
import { StriimTooltip } from "@striim/striim-ui";

import { Styles } from "../../utils/types";

/*
 * Show title only when text is overlapping
 * */
const EllipsisText: React.FC<{ text: string; "data-testid"?: string; sx?: CSSSelectorObject[string] }> = props => {
    const textRef = useRef(null);

    const [showTitle, setShowTitle] = useState(false);

    useEffect(() => {
        if (!textRef.current) return;
        setShowTitle(textRef.current.scrollWidth > textRef.current.clientWidth);
    }, [props.text]);

    return (
        <StriimTooltip title={showTitle ? props.text : ""}>
            <Box
                sx={[styles.ellipsis, props.sx]}
                ref={textRef}
                data-testid={props["data-testid"] || "text-ellipsis"}
            >
                {props.text}
            </Box>
        </StriimTooltip>
    );
};

export default EllipsisText;

const styles: Styles = {
    ellipsis: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
    }
};
